var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { utilBuildings } from "../../utils/utilBuildings";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { IconWithModifier } from "../generic/icon-with-modifier/IconWithModifier";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
import { MenuInfoTable } from "./MenuInfoTable";
var MenuInfoContentNonProductionDOM = /** @class */ (function (_super) {
    __extends(MenuInfoContentNonProductionDOM, _super);
    function MenuInfoContentNonProductionDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getStages = function (building) {
            return _this.isBaseBuilding(building)
                ? building.balancing.stage
                : building.balancing.outsideBuildingStage;
        };
        _this.getRows = function (building) {
            return _this.getStages(building).map(function (stage, index) {
                var values = _this.getRowContent(stage);
                var className = 
                // not using utilBuildings.getProtoStage(building) because here if
                // building.proto.stage is undefined we take a different route.
                building.proto.stage !== undefined && stage.level === building.proto.stage
                    ? IdStyles.StateSelected
                    : IdStyles.Empty;
                return (React.createElement("div", { className: "info-menu__table-tr " + className + " " + IdStyles.TableRow, key: stage.level }, values));
            });
        };
        // TODO: refactor to return proper header component
        _this.getHeaders = function (buildingStage) {
            var headers = [];
            var modifierIconProps = {
                icon: IdIcon.GreenArrowUpIcn,
                position: IdBadgePosition.Right,
                styleId: IdStyles.IconSmall,
            };
            var isBaseBuildingStageType = _this.isBaseBuildingStageType(buildingStage);
            // Add level
            headers.push(React.createElement("div", { className: "info-menu__table-th", key: 0 },
                React.createElement(IconWithModifier, { styleId: IdStyles.IconMedium, icon: IdIcon.FarmNameIcn, modifierIconProps: modifierIconProps })));
            // Add storage
            if (buildingStage.storageCapacity != undefined &&
                (buildingStage.storageCapacity > 0 || !isBaseBuildingStageType)) {
                headers.push(React.createElement("div", { className: "info-menu__table-th", key: 1 },
                    React.createElement(Icon, { icon: IdIcon.StorageIcn, styleId: IdStyles.IconMedium })));
            }
            if (_this.isBaseBuildingStageType(buildingStage)) {
                // Add workers
                if (buildingStage.workers != undefined) {
                    headers.push(React.createElement("div", { className: "info-menu__table-th", key: 2 },
                        React.createElement(Icon, { icon: IdIcon.WorkersIcn, styleId: IdStyles.IconMedium })));
                }
                // Add happiness
                if (buildingStage.happiness != undefined) {
                    headers.push(React.createElement("div", { className: "info-menu__table-th", key: 3 },
                        React.createElement(Icon, { icon: IdIcon.HappinessPositiveIcn, styleId: IdStyles.IconMedium })));
                }
                // Add Construction Buff
                if (buildingStage.buff) {
                    headers.push(React.createElement("div", { className: "info-menu__table-th", key: 4 },
                        React.createElement(Icon, { icon: IdIcon.ConstructionTimeIcn, styleId: IdStyles.IconMedium })));
                }
            }
            return headers;
        };
        _this.getRowContent = function (buildingStage) {
            var values = [];
            var isBaseBuildingStageType = _this.isBaseBuildingStageType(buildingStage);
            // Add level
            values.push(React.createElement("div", { className: "info-menu__table-td", key: 0 },
                React.createElement("div", { className: IdStyles.TextNormal },
                    React.createElement(NumberFormat, { amount: buildingStage.level }))));
            // Add storage
            if (buildingStage.storageCapacity != undefined &&
                (buildingStage.storageCapacity > 0 || !isBaseBuildingStageType)) {
                var format = isBaseBuildingStageType ? undefined : TypeNumberFormat.AddIncludingZero;
                values.push(React.createElement("div", { className: "info-menu__table-td", key: 1 },
                    React.createElement("div", { className: IdStyles.TextNormal },
                        React.createElement(NumberFormat, { amount: buildingStage.storageCapacity, format: format }))));
            }
            if (_this.isBaseBuildingStageType(buildingStage)) {
                // Add workers
                if (buildingStage.workers != undefined) {
                    values.push(React.createElement("div", { className: "info-menu__table-td", key: 2 },
                        React.createElement("div", { className: IdStyles.TextNormal },
                            React.createElement(NumberFormat, { amount: buildingStage.workers }))));
                }
                // Add happiness
                if (buildingStage.happiness != undefined) {
                    values.push(React.createElement("div", { className: "info-menu__table-td", key: 3 },
                        React.createElement("div", { className: IdStyles.TextNormal },
                            React.createElement(NumberFormat, { amount: buildingStage.happiness }))));
                }
                // Add Construction Buff
                if (buildingStage.buff) {
                    var buffAmount = buildingStage.buff.factorAddition * 100;
                    values.push(React.createElement("div", { className: "info-menu__table-td", key: 4 },
                        React.createElement("div", { className: IdStyles.TextNormal },
                            React.createElement(NumberFormat, { amount: buffAmount, format: TypeNumberFormat.SignedPercent }))));
                }
            }
            return values;
        };
        return _this;
    }
    MenuInfoContentNonProductionDOM.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.building !== undefined;
    };
    MenuInfoContentNonProductionDOM.prototype.render = function () {
        var building = this.props.building;
        var buildingStage = this.isBaseBuilding(building)
            ? utilBuildings.getBalancingStage(building)
            : building.balancing.outsideBuildingStage[(building.proto.stage || 1) - 1];
        var title = this.props.building.balancing.locaKey;
        var headers = this.getHeaders(buildingStage);
        var rows = this.getRows(building);
        return (React.createElement("div", { className: "info-menu-wrapper" },
            React.createElement("div", { className: "info-menu" },
                React.createElement("div", { className: IdStyles.InfoMenuTitleContainer + " flex flex--guts" },
                    React.createElement("div", null,
                        React.createElement(TextLoca, { id: title, className: IdStyles.HeadlineOne }))),
                React.createElement(MenuInfoTable, { headers: headers, rows: rows }))));
    };
    MenuInfoContentNonProductionDOM.prototype.isBaseBuilding = function (building) {
        // TODO: Refactor this to a better solution if any.
        return building.balancing.outsideBuildingStage == undefined;
    };
    MenuInfoContentNonProductionDOM.prototype.isBaseBuildingStageType = function (stage) {
        return "standard" in stage;
    };
    return MenuInfoContentNonProductionDOM;
}(React.Component));
export { MenuInfoContentNonProductionDOM };



//////////////////
// WEBPACK FOOTER
// ./src/features/info-menu/MenuInfoContentNonProductionDOM.tsx
// module id = 949
// module chunks = 3